import { InputNumber } from 'antd';

import {
    handleKpiIntegerInputKeyDown,
    KPI_INTEGER_INPUT_PROPS,
    KPI_RANGE_INPUT_CLASS,
    parseKpiIntegerInput,
} from 'components/molecules/PackArchitecture/kpiRangeSlider.utils';

type KpiRangeSliderInputsProps = {
    min: number;
    max: number;
    minInputLabel: string;
    maxInputLabel: string;
    minInputError: string | null;
    maxInputError: string | null;
    onMinInput: (value: number) => void;
    onMaxInput: (value: number) => void;
};

const KpiRangeSliderInputs = ({
    min,
    max,
    minInputLabel,
    maxInputLabel,
    minInputError,
    maxInputError,
    onMinInput,
    onMaxInput,
}: KpiRangeSliderInputsProps) => (
    <div className="flex flex-col gap-1">
        <div className="flex items-center gap-6">
            <div className="flex items-center gap-2">
                <span className="text-sm text-blackTransparent88">{minInputLabel}</span>
                <InputNumber
                    size="small"
                    controls={false}
                    className={`${KPI_RANGE_INPUT_CLASS} ${minInputError ? '[&_.ant-input-number]:!border [&_.ant-input-number]:!border-redAlt' : ''}`}
                    value={min}
                    {...KPI_INTEGER_INPUT_PROPS}
                    onKeyDown={handleKpiIntegerInputKeyDown}
                    onChange={(value) => {
                        const parsed = parseKpiIntegerInput(value);
                        if (parsed != null) onMinInput(parsed);
                    }}
                    onBlur={() => onMinInput(min)}
                />
            </div>
            <div className="flex items-center gap-2">
                <span className="text-sm text-blackTransparent88">{maxInputLabel}</span>
                <InputNumber
                    size="small"
                    controls={false}
                    className={`${KPI_RANGE_INPUT_CLASS} ${maxInputError ? '[&_.ant-input-number]:!border [&_.ant-input-number]:!border-redAlt' : ''}`}
                    value={max}
                    {...KPI_INTEGER_INPUT_PROPS}
                    onKeyDown={handleKpiIntegerInputKeyDown}
                    onChange={(value) => {
                        const parsed = parseKpiIntegerInput(value);
                        if (parsed != null) onMaxInput(parsed);
                    }}
                    onBlur={() => onMaxInput(max)}
                />
            </div>
        </div>
        {(minInputError ?? maxInputError) ? (
            <p className="mb-0 text-xs text-redAlt">{minInputError ?? maxInputError}</p>
        ) : null}
    </div>
);

export default KpiRangeSliderInputs;
